import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { Icon } from '../../../../common/components/icons';
import { sizeEnum } from '../../../../common/components/icons/Icon';
import Tooltip from '../../../../common/components/Tooltip';

const PilotNameColumn = ({ pilotName }) => {
  if (!pilotName) {
    return (
      <Tooltip title={i18n.t('patrol.message.missionPilotNotFound')} placement="bottom">
        <Icon icon="warning" size={sizeEnum.small} />
      </Tooltip>
    );
  }
  return <span>{pilotName}</span>;
};

PilotNameColumn.propTypes = {
  pilotName: PropTypes.string,
};

PilotNameColumn.defaultProps = {
  pilotName: undefined,
};

export default PilotNameColumn;
